import './Play.css'
import React from 'react';

export default function Play(){
    return(
        <div className="bg-yellow-500">
            <h1>Play!</h1>
        </div>
    );
}